import {
  TextField,
  Select,
  DatePicker,
  DateTimePicker,
  MaskedField
} from 'elentari'
import { withStyles } from '@material-ui/core'

export const CustomTextField = withStyles(theme => ({
  root: {
    '& label.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.72)'
    },
    '& input.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.72)'
    }
  }
}))(TextField)

export const CustomSelect = withStyles(theme => ({
  disabled: {
    color: 'rgba(0, 0, 0, 0.72)'
  }
}))(Select)

export const CustomDatePicker = withStyles(theme => ({
  root: {
    '& label.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.72)'
    },
    '& input.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.72)'
    }
  }
}))(DatePicker)

export const CustomDateTimePicker = withStyles(theme => ({
  root: {
    '& label.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.72)'
    },
    '& input.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.72)'
    }
  }
}))(DateTimePicker)

export const CustomMaskedField = withStyles(theme => ({
  root: {
    '& label.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.72)'
    },
    '& input.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.72)'
    }
  }
}))(MaskedField)
